<script setup>

import BaseModalSimple from "@/Components/UI/modals/BaseModalSimple.vue";
import {usePage} from "@inertiajs/vue3";
import {ref} from "vue";
import BaseButton from "@/Components/UI/buttons/BaseButton.vue";

const showFeedbackForm = ref(false);

const props = defineProps({
    class: String,
})

</script>

<template>
    <BaseButton variant="primary" v-if="usePage().props.permissions.view.payments"
                       :class="props.class"
                       @click="showFeedbackForm=true">
        Связаться с продажами
    </BaseButton>

    <BaseModalSimple :show="showFeedbackForm"
                     max-width="xl"
                     @close="showFeedbackForm = false">
        <template #title>Оставьте заявку</template>
        <template #content>
            <div class="pt-10">
                <component :is="'script'"
                           data-b24-form="inline/158/a0hdz9"
                           data-skip-moving="true">
                    (function(w,d,u){var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
                    var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
                    })(window,document,'https://cdn-ru.bitrix24.ru/b292889/crm/form/loader_158.js');
                </component>
            </div>
        </template>
    </BaseModalSimple>
</template>
